export default __webpack_public_path__ + "static/media/purchase-return.0691b23e.svg";